export const drawArea = (
  context,
  obj,
  canvasOffset,
  zoom,
  selectedArea,
  seatingTickets
) => {
  const centerX = obj.x + obj.width / 2;
  const centerY = obj.y + obj.height / 2;
  const findTicket = (tierID) => {
    return seatingTickets.find((tier) => tier.tierID === tierID);
  };
  const assigned = findTicket(obj.tierID);

  context.save();
  context.scale(zoom, zoom);
  context.translate(centerX + canvasOffset.x, centerY + canvasOffset.y);
  context.rotate((obj.rotation * Math.PI) / 180);

  // Draw selection border
  if (selectedArea.find((o) => o.id === obj.id)) {
    context.strokeStyle = "black";
    context.lineWidth = 5;
    context.strokeRect(-obj.width / 2, -obj.height / 2, obj.width, obj.height);
  }

  // Draw the main area rectangle
  context.fillStyle = assigned ? (obj.tierColor || obj.color) : "black";
  context.fillRect(-obj.width / 2, -obj.height / 2, obj.width, obj.height);

  // Draw seat squares over the area
const rows = obj.rowCount?? 0;
const cols = obj.columnCount?? 0;
const spacing = 2; // space between seats
const padding = 8;  // padding inside the rectangle edges

// Calculate available width/height for seats after removing padding on both sides
const availableWidth = obj.width - padding * 2 - spacing * (cols - 1);
const availableHeight = obj.height - padding * 2 - spacing * (rows - 1);

// Calculate seat size based on available space
const seatWidth = availableWidth / cols;
const seatHeight = availableHeight / rows;

const startX = -obj.width / 2 + padding;
const startY = -obj.height / 2 + padding;

context.fillStyle = "white";

for (let row = 0; row < rows; row++) {
  for (let col = 0; col < cols; col++) {
    const x = startX + col * (seatWidth + spacing);
    const y = startY + row * (seatHeight + spacing);
    context.fillRect(x, y, seatWidth, seatHeight);
  }
}

  // Draw area name text
 const baseFontSize = 12; // Base font size at zoom = 1
const minFontSize = 10;  // Minimum font size to keep readability
const maxFontSize = 24;  // Max font size to avoid huge text

// Inverse scaling: as zoom increases, font size decreases proportionally
let fontSize = baseFontSize / zoom;

// Clamp font size to min and max values
fontSize = Math.min(Math.max(fontSize, minFontSize), maxFontSize);

context.fillStyle = "black";
context.font = `700 ${fontSize}px Arial`;
context.textAlign = "center";
  context.textBaseline = "middle";
  context.fillText(obj.name, 0, 0);

  context.restore();
};




  // // grid params
  // const rows    =  10;
  // const cols    =  20;
  // const spacing = 2;
  // const padding = 8;

  // // available space inside padding
  // const availableWidth  = obj.width  - padding*2 - spacing*(cols-1);
  // const availableHeight = obj.height - padding*2 - spacing*(rows-1);

  // // per-cell dimensions
  // const cellW = availableWidth  / cols;
  // const cellH = availableHeight / rows;

  // // **BIGGER CIRCLES**: default to 90% fill
  // const fillRatio = obj.circleFillRatio ?? 0.9;
  // const radiusRel = Math.min(cellW, cellH) * fillRatio / 2;

  // // fixed override if you want exact px-size
  // const radius = obj.circleRadius != null
  //   ? obj.circleRadius
  //   : radiusRel;

  // // origin at top-left of padded box
  // const startX = -obj.width/2 + padding;
  // const startY = -obj.height/2 + padding;

  // // draw circles
  // context.fillStyle = "white";
  // for (let r = 0; r < rows; r++) {
  //   for (let c = 0; c < cols; c++) {
  //     const cx = startX + c*(cellW + spacing) + cellW/2;
  //     const cy = startY + r*(cellH + spacing) + cellH/2;
  //     context.beginPath();
  //     context.arc(cx, cy, radius, 0, Math.PI*2);
  //     context.fill();
  //   }
  // }